import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CompanyWhiteIcon } from '../../asset';
import { ROUTES } from '../../constant/routeConstant';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import * as PortalServices from '../../service/portalServices';

const SelectPortal = () => {
  const [activeHover, setActiveHover] = useState('');
  const navigate = useNavigate();
  const { token, mapping_user } = useSelector((state) => state.auth);


  const dispatch = useDispatch();

  const onMouseEnter = (evt) => {
    setActiveHover(evt.target.id);
  }

  const onMouseLeave = () => {
    setActiveHover('');
  }

  useEffect(() => {
    getMapping();
    // eslint-disable-next-line
  },[]);

  const getMapping = async () => {
    await PortalServices.getMappingUser(token, dispatch);
  }

  const setUser = async (data) => {
    const body = {
      client_id: data?.client_id,
      grolog_account_id: data?.grolog_account_id,
      token: token
    }
    const res = await PortalServices.setUser(token, body, dispatch);

    if (res?.isSetUser) {
      navigate(ROUTES.WELCOME);
    }
  }

  const handleKlik = async (data) => {
    await setUser(data);
  }

  return (
    <div className=' flex flex-col bg-gray-1000 h-full w-[112.55rem] -ml-44 mt-[3rem]'>
      <p className=' font-sans-bold text-[1.75rem]'> GroLog Account Portal </p>
      <p className=' font-roboto text-[1rem] text-black-300 font-medium mt-5 mb-2'>
        Select GroLog Account
      </p>
        <div className=' flex flex-wrap'>
          {
            mapping_user && mapping_user.map((item, index) => {
              return(
                <div key={index} className=' w-1/4 flex justify-start flex-wrap gap-2 overflow-auto mb-5 cursor-pointer'
                  onClick={() => { handleKlik(item)} }>
                  <div
                    className='w-[25rem] h-[6rem] items-center px-3 border-l-8 flex bg-white-100 border-pink-200 rounded-md hover:bg-pink-200'
                    onMouseEnter={(evt) => onMouseEnter(evt)}
                    onMouseLeave={() => onMouseLeave()}
                  >
                    <div
                      className={`rounded-full w-[3.5rem] h-[3.5rem] items-center justify-center flex bg-gray-1001`}
                    >
                      <img src={`${item?.company_logo ? item?.company_logo : CompanyWhiteIcon }` } alt='icon-company' width={20} />
                    </div>
                    <div className=' font-roboto text-xs flex flex-col justify-start pl-4'>
                      <p className='mb-2 text-gray-600 text-[1rem] font-medium'>{item.grolog_account_id}</p>
                      <p className=' font-roboto-medium text-[1rem]'>{item.grolog_account_name}</p>
                    </div>
                  </div>
                </div>
              )
            })
          }
        </div>
    </div>
  )
}

export default SelectPortal;